// extracted by mini-css-extract-plugin
export default {"price":"I6-z","onSale":"J6-z","msrpLabelPrice":"K6-z","msrpLabel":"L6-z","originalPrice":"M6-z","percentOff":"N6-z"};